import { apiConnector } from "../apiconnector";
import toast from "react-hot-toast";
import { drawingSheetEndpoints } from "../apis";
// import { MARK_COMPLETED_DRAWING_API } from "../apis";

// Create a new Drawing Sheet
export const createDrawingSheet = async (data) => {
  try {
    const response = await apiConnector(
      "POST",
      drawingSheetEndpoints.CREATE_DRAWINGSHEET_API,
      data,
    );
    toast.success("Drawing sheet created successfully");
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to create drawing sheet");
    throw err;
  }
};

// Get all Drawing Sheets assigned to the user/admin
export const getAllDrawingSheets = async () => {
  try {
    const response = await apiConnector(
      "GET",
      drawingSheetEndpoints.GET_ALL_DRAWINGSHEETS_API,
      null,
    );
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to fetch drawing sheets");
    throw err;
  }
};

// Get details of a single Drawing Sheet by ID
export const getSingleDrawingSheet = async (id) => {
  try {
    const response = await apiConnector(
      "GET",
      drawingSheetEndpoints.GET_SINGLE_DRAWINGSHEET_API(id),
      null,
    );
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to fetch drawing sheet details");
    throw err;
  }
};

// Delete a Drawing Sheet by ID
export const deleteDrawingSheet = async (id) => {
  try {
    const response = await apiConnector(
      "DELETE",
      drawingSheetEndpoints.DELETE_DRAWINGSHEET_API(id),
      null,
    );
    toast.success("Drawing sheet deleted successfully");
    return response;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to delete drawing sheet");
    throw err;
  }
};

// Fetch drawing sheets assigned to a particular employee — for employee dashboard
export const getAdminDrawingsWithNodes = async () => {
  try {
    const response = await apiConnector(
      "GET",
      drawingSheetEndpoints.GET_ADMIN_DRAWING_SHEET,
      null,
    );
    return response.data;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to fetch drawings sheet");
    throw err;
  }
};
export const getAssignedDrawings = async () => {
  try {
    const response = await apiConnector(
      "GET",
      drawingSheetEndpoints.GET_ASSIGNED_DRAWINGS_API,
      null,
    );
    return response.data;
  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to fetch assigned drawings");
    throw err;
  }
};




export async function markCompletedDrawing(drawingSheetId) {
  try {
    const response = await apiConnector("POST", drawingSheetEndpoints.MARK_COMPLETED_DRAWING_API, {
      drawingSheetId,
    });

    return response;
  } catch (error) {
    toast.error(error.response?.data?.message || "Failed to mark drawing as completed");
    return { success: false, message: "Failed to mark as completed" };
  }
}
